{
  "markets": {
    "title": "Countries and currencies",
    "intro": "Where the website sells, in which currency and how tax and import duties work for each group of countries.",
    "read_only": "Shown for checking only. Import duties are changed in Shipping → Import duties; website languages in Website languages.",
    "to_duties": "Change import duties",
    "to_languages": "Website languages",
    "error": "The countries could not be loaded.",
    "empty": "No countries are set up yet.",
    "default": "Main",
    "on": "Selling",
    "off": "Not selling",
    "rest_of_world": "Every other country",
    "countries_more_one": "{{list}} + {{count}} more",
    "countries_more_other": "{{list}} + {{count}} more",
    "currency": "Currency",
    "fixed_rate": "1 JPY = {{rate}} {{currency}}",
    "fx": {
      "own_table": "shop's own exchange rates",
      "fixed": "fixed exchange rate",
      "stripe_adaptive": "converted by the card payment service (later phase)"
    },
    "tax": "Consumption tax",
    "tax_mode": {
      "domestic": "Prices include 10% consumption tax",
      "export": "Export — no Japanese consumption tax"
    },
    "duties": "Import duties",
    "duties_none": "None (sold in Japan)",
    "duties_mode": {
      "DDU": "Customer pays on arrival (estimate {{rate}}%)",
      "DDP": "Collected at checkout ({{rate}}%)"
    },
    "free_shipping": "Free shipping from",
    "free_shipping_none": "Not set"
  },
  "domains": {
    "title": "Web address (domain)",
    "intro": "The addresses of the website, this admin and the register. Only for checking — IT changes them.",
    "website": "Website (customers)",
    "admin": "Admin (this screen)",
    "register": "Register (shop counter)",
    "copy": "Copy",
    "copied": "Address copied.",
    "copy_failed": "Could not copy — select the address and copy it by hand.",
    "how_to_change": "To use a new domain, ask IT (it is set up once with the domain company and the server)."
  },
  "lang": {
    "ja": "日本語",
    "en": "English"
  },
  "store": {
    "title": "Shop details",
    "intro": "Type the shop's details once — they are used on the legal pages of the website and in the footer of every e-mail.",
    "needs_content": "Only staff who may edit the website content can open the shop details.",
    "error": "The shop details could not be loaded.",
    "facts_title": "About the shop",
    "facts_intro": "Japanese is required by law; English is shown to overseas customers.",
    "read_only": "Only the owner can change the shop details. You can look.",
    "kobutsu_title": "Second-hand dealer licence (古物商許可)",
    "fields": {
      "shopName": "Shop / company name (販売業者)",
      "representative": "Person responsible (代表者)",
      "address": "Address (所在地)",
      "phone": "Phone",
      "phoneHours": "Phone hours",
      "email": "E-mail for customers",
      "website": "Website address",
      "commission": "Public Safety Commission (公安委員会)",
      "licenseNumber": "Licence number (古物商許可番号)",
      "nameKana": "Shop name in katakana (フリガナ)",
      "postalCode": "Postcode (〒)"
    },
    "help": {
      "shopName": "The name on the licence and the invoice — the company or your own name.",
      "representative": "The person who is responsible for the shop.",
      "address": "Where the shop is. Customers must be able to reach you here.",
      "phone": "A number customers can call.",
      "phoneHours": "When the phone is answered, e.g. 11:00–19:00, closed Tuesdays.",
      "email": "Where customers write to. Also shown in e-mails.",
      "website": "The address of the website, starting with https://",
      "commission": "The commission that gave the licence, e.g. 東京都公安委員会.",
      "licenseNumber": "The number on the licence (12 digits). It must be shown on the website.",
      "nameKana": "The shop name as it is read, in katakana — e.g. カードショップトウキョウ.",
      "postalCode": "7 digits, e.g. 150-0001. It is shown before the address on the legal pages."
    },
    "problems": {
      "email": "This does not look like an e-mail address.",
      "phone": "Use digits, spaces, + or - only.",
      "website": "Start with https://",
      "postalCode": "Type 7 digits, e.g. 150-0001.",
      "nameKana": "Use katakana only (e.g. カードショップ).",
      "licenseNumber": "Numbers only, e.g. 第301012345678号 — the number on your 古物商許可証."
    },
    "save": "Save shop details",
    "undo": "Undo my changes",
    "saved": "Saved. Publish the pages below so customers see the new details.",
    "saved_no_footer": "Saved on the legal pages. The e-mail footer could not be updated — try again later.",
    "part_footer": "footer of e-mails",
    "saved_parts": "Saved: {{parts}}.",
    "not_saved": "Not saved: {{parts}} — try saving again.",
    "not_saved_conflict": "Not saved: {{parts}} — someone else changed it first. Press \"Load latest\" or save again after checking.",
    "conflict": "Someone else changed these pages first. The newest details are shown — make your change again.",
    "payments_used": "Payment methods updated from the payment settings.",
    "where_used": "Used on: the top of the back office, receipts, 特定商取引法に基づく表記, 古物営業法に基づく表示, Contact page, footer of e-mails.",
    "tax_title": "Tax registration",
    "to_tax": "Open tax settings",
    "tax_error": "The tax settings could not be loaded.",
    "t_number": "Invoice number (T-number)",
    "t_number_missing": "Not entered yet",
    "business_name": "Registered name",
    "business_type": "Business type",
    "business_types": {
      "individual": "Sole proprietor (個人事業主)",
      "corporation": "Company (法人)"
    },
    "not_decided": "Not decided yet",
    "tax_free": "Tax-free sales (免税)",
    "tax_free_yes": "Licensed",
    "tax_free_no": "Not licensed",
    "logo_title": "Shop logo",
    "logo_help": "Shown at the top of the back office for everyone. Choose a picture from the media library.",
    "logo_choose": "Choose a picture",
    "logo_change": "Change picture",
    "logo_remove": "Remove logo",
    "logo_none": "No logo yet — the shop name is shown instead.",
    "logo_picker": "Choose the shop logo",
    "not_saved_record": "The shop details were not saved — someone else changed them first. Load the latest and try again.",
    "record_error": "The shop details could not be saved. Nothing was changed.",
    "signage": {
      "title": "Signs to print",
      "intro": "PDFs drawn from the details above. Print at 100 % and check the size once with a ruler.",
      "hyoshiki": "Secondhand dealer sign (標識, 8 × 16 cm)",
      "identity": "ID check notice for the counter (A4)",
      "needs_permit": "The dealer sign needs the permit number (12 digits), the Public Safety Commission and the shop name above."
    }
  },
  "tokushoho": {
    "title": "Legal notice page (特定商取引法に基づく表記)",
    "ring": "{{filled}} of {{total}} items filled",
    "filled": "{{filled}} of {{total}} items have Japanese text.",
    "all_done": "All 14 items are filled.",
    "law_link": "What the law asks (消費者庁)",
    "fill": "Fill in the items",
    "returns_missing": "⑪ Returns (返品特約) is empty. If it is not shown, buyers may cancel within 8 days after receiving the goods (特商法 15条の3).",
    "returns_guide": "Guideline",
    "payments_differ": "⑧ Payment methods does not match the ways to pay that are on: “{{text}}”.",
    "use_payments": "Use this text",
    "license_missing": "The 古物商許可番号 is empty — it must be shown on the website (古物営業法). Selling still works.",
    "kobutsu_link": "About the licence (警視庁)",
    "still_empty": "Still empty:",
    "item_label": "{{no}}. {{label}}",
    "items": {
      "seller": {
        "label": "Seller",
        "help": "The shop or company name."
      },
      "representative": {
        "label": "Person responsible",
        "help": "Name of the representative."
      },
      "address": {
        "label": "Address",
        "help": "Where the business is."
      },
      "phone": {
        "label": "Phone and hours",
        "help": "A number and when it is answered."
      },
      "email": {
        "label": "E-mail",
        "help": "Where customers write to."
      },
      "price": {
        "label": "Prices",
        "help": "How prices are shown (tax included)."
      },
      "other_fees": {
        "label": "Other costs",
        "help": "Shipping, transfer fees, import duties abroad."
      },
      "payment_methods": {
        "label": "Payment methods",
        "help": "The ways to pay that are on."
      },
      "payment_timing": {
        "label": "When to pay",
        "help": "E.g. within 3 days of ordering."
      },
      "delivery_timing": {
        "label": "When it is sent",
        "help": "How long preparing and shipping take."
      },
      "returns": {
        "label": "Returns (返品特約)",
        "help": "What can be returned and when."
      },
      "quantity": {
        "label": "Quantity limits",
        "help": "E.g. one of each card per customer."
      },
      "other": {
        "label": "Other notes",
        "help": "Anything else the customer should know."
      },
      "validity": {
        "label": "Order validity / cancel",
        "help": "How long an unpaid order is kept."
      }
    },
    "what_items": "What the 14 items are"
  },
  "publish": {
    "title": "Publish on the website",
    "pages": {
      "tokushoho": "特定商取引法に基づく表記",
      "kobutsu": "古物営業法に基づく表示",
      "contact": "Contact"
    },
    "published_on": "On the website since",
    "not_published": "Not on the website yet",
    "changes_waiting": "Changes not published",
    "save_first": "You have unsaved shop details — save them first, then publish.",
    "missing": "“{{page}}” cannot go on the website yet — these items are empty:",
    "button": "Update the pages on the website (表記ページを更新)",
    "needs_permission": "A manager or the owner publishes.",
    "nothing": "Everything is on the website.",
    "done": "On the website now: {{pages}}.",
    "confirm_title": "Update the legal pages on the website?",
    "confirm_body": "Customers will see the new text of: {{pages}}. Write what changed — it is kept in the page history.",
    "confirm": "Update the pages",
    "show_preview": "Show the page as customers see it",
    "hide_preview": "Hide the page",
    "preview_title": "Legal notice page on the website",
    "history": "Earlier versions",
    "version": "Version {{version}}"
  },
  "policy_fields": {
    "business_name": "Seller",
    "representative": "Person responsible",
    "address": "Address",
    "phone": "Phone",
    "phone_hours": "Phone hours",
    "email": "E-mail",
    "url": "Website",
    "price_display": "Prices",
    "additional_fees": "Other costs",
    "payment_methods": "Payment methods",
    "payment_timing": "When to pay",
    "delivery_timing": "When it is sent",
    "return_policy": "Returns",
    "quantity_limit": "Quantity limits",
    "application_validity": "Order validity",
    "kobutsu_license": "古物商許可",
    "other_notes": "Other notes",
    "licensee_name": "Licence holder",
    "commission_name": "Public Safety Commission",
    "license_number": "Licence number",
    "notified_url": "Notified website",
    "hours": "Opening hours",
    "body": "Text of the page"
  },
  "web_orders": {
    "title": "Checkout",
    "intro": "How the website takes orders.",
    "error": "The switch could not be read just now.",
    "switch_title": "Take orders on the website",
    "state_open": "Taking orders",
    "state_paused": "Paused",
    "explain_open": "Customers can order on the website. Pause it when something is wrong (wrong prices, a problem with stock, the shop is closed for a while).",
    "explain_paused": "The website shows a notice that orders are paused. Customers can still look at the cards; they cannot place an order. The shop counter is not affected.",
    "pause": "Pause web orders",
    "resume": "Take orders again",
    "confirm_title": "Pause orders on the website?",
    "confirm_body": "Customers will see a notice and cannot place orders until you switch it back. Orders already placed are not changed.",
    "paused_done": "Web orders are paused.",
    "resumed_done": "The website takes orders again.",
    "who_can": "Only the owner or a manager can change this."
  }
}
